import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PoliticaDatosComponent } from './politica-datos/politica-datos.component';
import { InicioComponent } from './inicio/inicio.component';
import { AboutUsComponent } from './about-us/about-us.component';

const routes: Routes = [
  {
    path: 'politica-tratamiento-datos',
    component: PoliticaDatosComponent
  },
  {
    path: 'home',
    component: InicioComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicPagesRoutingModule { }
